









































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Outlet, Retailer } from '@/models/Outlet';
import ImagePopup from '@/components/Inspiration/ImagePopup.vue';
import { SideboardGalleryFilter, SideboardGalleryFilterItem } from '@/models/SideboardGallery';
import OutletContactForm from '@/components/SideboardGallery/OutletContactForm.vue';
import { websiteText } from '@/mixins/websiteTexts';

@Component({
    components: {
        OutletContactForm,
        ImagePopup
    }
})
export default class Outlets extends Vue {
    protected outlets!: Outlet[];
    protected filteredOutlets!: Outlet[];
    protected isGlobal: boolean;
    protected showSideboard: boolean = false;
    protected selectedOutlet!: Outlet;
    protected showSelectedOutlet: boolean = false;
    protected lastClickedNode = null;
    protected selectedImageIndex: number = 0;

    // filter-settings
    protected toogleFilterMobile: boolean = false;
    protected filterOptions!: SideboardGalleryFilter;

    private bodyEl: HTMLBodyElement | null = null;

    constructor() {
        super();
        this.outlets = JSON.parse(this.$attrs['data-outlets']);
        this.filteredOutlets = this.outlets;
        this.isGlobal = JSON.parse(this.$attrs['data-is-global']);

        this.bodyEl = document.querySelector('body');

        this.$attrs['data-outlets'] = '';
        this.$attrs['data-is-global'] = '';

        this.filterOptions = {
            Retailers: [],
            Type: []
        };
    }

    private _websiteText(text: string, extraValues?: string[]) {
        return websiteText(text, extraValues);
    }

    destroyed() {
        document.removeEventListener('mousedown', this.clickHandler);
    }
    private mounted() {
        this.getFilterOptions();
        this.runFilter();
        document.addEventListener('mousedown', this.clickHandler);
    }

    private clickHandler(e: any) {
        this.lastClickedNode = e.target;
        const sideBoard = document.querySelector('.sideboard-gallery__sideboard');
        const modalWindow = document.getElementById('modals-container');

        if (sideBoard && !sideBoard.contains(this.lastClickedNode) && (!modalWindow || !modalWindow.children.length)) {
            this.closeSideboard();
        }
    }

    private showImage(imageUrl: string) {
        this.$modal.show(
            ImagePopup,
            {
                imageUrl
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }

    private toggleFilter(e: any) {
        const filter = e.currentTarget;

        if (!filter.classList.contains('open')) {
            this.closeFilters();
            filter.classList.add('open');
        } else if (filter.classList.contains('open') && e.srcElement.classList.contains('toggle-arrow')) {
            this.closeFilters();
        }
    }

    private showClearFilter(): boolean {
        if (this.filterOptions.Retailers.filter(x => x.Selected).length > 0) {
            return true;
        }
        return false;
    }

    private closeFilters() {
        const filters = document.querySelectorAll('.filter-item');
        filters.forEach((filter: any) => {
            filter.classList.remove('open');
        });
    }

    private selectedFilter(id: string): boolean {
        if (this.filterOptions.Retailers.findIndex(obj => obj.Id === id && obj.Selected) !== -1) {
            return true;
        }
        return false;
    }

    private selectedTypeFilter(id: string): boolean {
        if (this.filterOptions.Type.findIndex(obj => obj.Id === id && obj.Selected) !== -1) {
            return true;
        }
        return false;
    }

    private selectFilter(id: string) {
        const objIndex = this.filterOptions.Retailers.findIndex(obj => obj.Id === id);

        this.filterOptions.Retailers[objIndex].Selected = !this.filterOptions.Retailers[objIndex].Selected;

        this.runFilter();
    }

    private selectTypeFilter(id: string) {
        const objIndex = this.filterOptions.Type.findIndex(obj => obj.Id === id);

        this.filterOptions.Type[objIndex].Selected = !this.filterOptions.Type[objIndex].Selected;

        this.runFilter();
    }

    private clearFilter() {
        this.filterOptions.Retailers.forEach(obj => (obj.Selected = false));
        this.filterOptions.Type.forEach(obj => (obj.Selected = false));

        this.runFilter();
    }

    private runFilter() {
        this.filteredOutlets = this.outlets;

        if (this.filterOptions.Retailers.findIndex(obj => obj.Selected) === -1) {
            // this.filteredOutlets = this.outlets;
        } else {
            const selectedRetailers = this.filterOptions.Retailers.filter(obj => obj.Selected);
            this.filteredOutlets = this.filteredOutlets.filter(x => selectedRetailers.some(y => y.Id === x.Retailer.City));
        }

        if (this.filterOptions.Type.findIndex(obj => obj.Selected) === -1) {
            // this.filteredOutlets = this.outlets;
        } else {
            const selectedTypes = this.filterOptions.Type.filter(obj => obj.Selected);
            this.filteredOutlets = this.filteredOutlets.filter(x => selectedTypes.some(y => y.Id === x.Type));
        }
    }

    private getFilterOptions() {
        this.outlets.forEach(outletItem => {
            const retailer = outletItem.Retailer;
            const objIndex = this.filterOptions.Retailers.findIndex(obj => obj.Id === retailer.City);

            if (objIndex === -1) {
                const newRetailerFilterItem: SideboardGalleryFilterItem = {
                    Id: retailer.City,
                    Name: retailer.City,
                    Amount: 1,
                    Selected: false
                };
                this.filterOptions.Retailers.push(newRetailerFilterItem);
            } else if (objIndex >= 0) {
                this.filterOptions.Retailers[objIndex].Amount += 1;
            }

            this.filterOptions.Retailers.sort((a, b) => {
                const nameA = a.Name.toUpperCase();
                const nameB = b.Name.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
        });

        this.outlets.forEach(outletItem => {
            const type = outletItem.Type;
            const objIndex = this.filterOptions.Type.findIndex(obj => obj.Id === type);

            if (objIndex === -1 && type !== null) {
                const newTypeFilterItem: SideboardGalleryFilterItem = {
                    Id: type,
                    Name: this._websiteText('retailer.type.' + type),
                    Amount: 1,
                    Selected: type === 'WholeSetup' && this.isGlobal ? true : false
                };
                this.filterOptions.Type.push(newTypeFilterItem);
            } else if (objIndex >= 0 && type !== null) {
                this.filterOptions.Type[objIndex].Amount += 1;
            }

            this.filterOptions.Type.sort((a, b) => {
                const nameA = a.Name.toUpperCase();
                const nameB = b.Name.toUpperCase();
                if (nameA > nameB) {
                    return -1;
                }
                if (nameA < nameB) {
                    return 1;
                }
                return 0;
            });
        });
    }

    private closeSideboard() {
        if(this.bodyEl) {
            this.bodyEl.style.overflow = '';
        }

        this.removeBodyClass();
        this.showSideboard = false;
        this.showSelectedOutlet = false;
        this.selectedOutlet = {} as Outlet;
    }

    private openSideboard(outlet: Outlet) {
        if(this.bodyEl) {
            this.bodyEl.style.overflow = 'hidden';
        }
        this.addBodyClass();
        this.showSideboard = true;
        this.showSelectedOutlet = false;
        this.selectedOutlet = outlet;
        this.showSelectedOutlet = true;
    }

    private scroll(adjust: number) {
        const element = document.querySelector('#scroller');
        let elementWidth: number = 400 * adjust;
        let elementMargin: number = 20;

        if (element != null && element.childNodes != null && element.childNodes.length > 0) {
            // @ts-ignore
            const li = element.childNodes[0];

            if (li != null) {
                // @ts-ignore
                const style = window.getComputedStyle(li);
                elementMargin = Number(style.paddingRight.replace('px', ''));
            }

            // @ts-ignore
            elementWidth = (element.offsetWidth + elementMargin * 2) * adjust;

            if (adjust === 0) {
                element.scrollLeft = 0;
            } else {
                element.scrollTo({
                    left: element.scrollLeft + elementWidth,
                    behavior: 'smooth'
                });
            }
        }
    }

    private scrollTo(id: any) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    }

    private removeBodyClass() {
        const body = document.body;

        if (body.classList.contains('body-slided')) {
            body.classList.remove('body-slided');
        }
    }
    private addBodyClass() {
        const body = document.body;
        if (!body.classList.contains('body-slided')) {
            body.classList.add('body-slided');
        }
    }

    private selectedImage(index: number) {
        const element = document.getElementById('image-' + index);
        if (element) {
            const elementContainer = document.querySelector('#scroller');
            const offsetLeft = element.offsetLeft;
            if (elementContainer) {
                elementContainer.scrollTo({
                    left: offsetLeft
                });
            }
        }
        this.scrollTo('sideboard-top');
    }

    private changeImage(n: number) {
        const imagesLength = this.selectedOutlet.Images.length;
        this.selectedImageIndex = (((this.selectedImageIndex + n) % imagesLength) + imagesLength) % imagesLength;
    }

    private openDropdown(e: any) {
        const dropdown = e.currentTarget;

        if (!dropdown.classList.contains('open')) {
            this.closeDropdown();
            dropdown.classList.add('open');
        } else if (dropdown.classList.contains('open')) {
            this.closeDropdown();
        }
    }
    private closeDropdown() {
        const dropdowns = document.querySelectorAll('.social-item');
        dropdowns.forEach((dropdown: any) => {
            dropdown.classList.remove('open');
        });
    }
    private copyLink(e: any) {
        const linkElem = e.currentTarget;
        const url = linkElem.getAttribute('url');
        const el = document.createElement('textarea');
        el.value = url;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
}
